(function () {
  const button = document.querySelector('.scroll-to-top');
  if (!button) return;

  const showAfter = 800;
  let visible = false;

  // Collection and search pages set overflow on <body> (klevu-collection.css), and
  // an open drawer moves overflow onto <html> (base.css), either of which can make
  // <body> the scroll container instead of the viewport. Read both sources.
  function scrollOffset() {
    return Math.max(window.scrollY, document.body.scrollTop, document.documentElement.scrollTop);
  }

  function update() {
    const shouldShow = scrollOffset() > showAfter;
    if (shouldShow === visible) return;
    visible = shouldShow;
    button.classList.toggle('scroll-to-top--visible', shouldShow);
  }

  button.addEventListener('click', function () {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    // Whichever of the two is not the scroll container simply ignores this.
    window.scrollTo({ top: 0, behavior });
    document.body.scrollTo({ top: 0, behavior });
  });

  // Capture phase, because a scroll event on <body> as an overflow container is
  // fired at <body> and does not bubble up to window.
  window.addEventListener('scroll', update, { passive: true, capture: true });
  update();
})();
